import type React from 'react';

import { AttachDepartmentListsButton, CreateDepartmentListsButton } from '@vlabs/monokit/features';
import type { DepartmentId } from '@vlabs/api/artemy/model';

import { DepartmentListListProvider, useDepartmentListListContext } from './context';
import { DepartmentListListModeSwitch } from './DepartmentListListModeSwitch';
import { useDepartmentListListTranslation } from './i18n';
import { OwnershipDepartmentLists } from './OwnershipDepartmentLists';
import { ViewDepartmentLists } from './ViewDepartmentLists';
import { FoldableEntity } from '../../../shared/ui/foldable-entity';

interface DepartmentListListProps {
  departmentId: DepartmentId;
}

function DepartmentListListContent({
  departmentId,
}: DepartmentListListProps): React.JSX.Element {
  const { t } = useDepartmentListListTranslation();
  const { mode } = useDepartmentListListContext();

  return (
    <FoldableEntity
      actions={mode === 'ownership' ? (
        <CreateDepartmentListsButton departmentId={departmentId} />
      ) : (
        <AttachDepartmentListsButton departmentId={departmentId} />
      )}
      heading={t('title')}
    >
      <DepartmentListListModeSwitch />
      {mode === 'ownership' && <OwnershipDepartmentLists departmentId={departmentId} />}
      {mode === 'view' && <ViewDepartmentLists departmentId={departmentId} />}
    </FoldableEntity>
  );
}

function DepartmentListList({
  departmentId,
}: DepartmentListListProps): React.JSX.Element {
  return (
    <DepartmentListListProvider>
      <DepartmentListListContent departmentId={departmentId} />
    </DepartmentListListProvider>
  );
}

export { DepartmentListList };
